<template>
  <a-config-provider :locale="locale" :auto-insert-space-in-button="false">
    <RouterView v-if="isRouterReady" v-slot="{ Component, route }">
      <BaseLayout v-if="!isFullScreenRoute(route)" @refresh="refreshPage">
        <keep-alive :max="50">
          <component
            :is="Component"
            v-if="Component && route.meta.keepAlive"
            :key="pageCacheKey(route)"
          />
        </keep-alive>
        <component
          :is="Component"
          v-if="Component && !route.meta.keepAlive"
          :key="pageCacheKey(route)"
        />
      </BaseLayout>
      <component
        :is="Component"
        v-else-if="Component"
        :key="pageCacheKey(route)"
      />
    </RouterView>
  </a-config-provider>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import BaseLayout from '@/layout/index.vue'
import { useRouter, type RouteLocationNormalizedLoaded } from 'vue-router'

import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
const locale = zhCN

const router = useRouter()
const isRouterReady = ref(false)
/** 仅刷新当前页时递增对应 nonce，避免误清其它页的 keep-alive */
const pageRefreshNonce = ref<Record<string, number>>({})

onMounted(() => {
  router.isReady().then(() => {
    isRouterReady.value = true

    const mode = import.meta.env.MODE
    const apiHost = import.meta.env.VITE_APP_HOST
    const mqttHostAlarm = import.meta.env.VITE_MQTT_HOST_ALARM
    const mqttHostPoint = import.meta.env.VITE_MQTT_HOST_POINT

    console.log('📘📘📘 Environment LOG 📘📘📘', {
      mode,
      apiHost,
      mqttHostAlarm,
      mqttHostPoint,
    })
  })
})

const isFullScreenRoute = (r: RouteLocationNormalizedLoaded) => Boolean(r.meta?.isFullScreen)

const routeCacheBase = (r: RouteLocationNormalizedLoaded) => {
  const meta = r.meta as { usePathKey?: boolean }
  return meta.usePathKey ? r.fullPath : String(r.name || r.path)
}

const pageCacheKey = (r: RouteLocationNormalizedLoaded) => {
  const base = routeCacheBase(r)
  return `${base}__${pageRefreshNonce.value[base] || 0}`
}

const refreshPage = () => {
  const base = routeCacheBase(router.currentRoute.value)
  pageRefreshNonce.value = {
    ...pageRefreshNonce.value,
    [base]: (pageRefreshNonce.value[base] || 0) + 1,
  }
}
</script>

<style scoped lang="less"></style>
